import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Swal from "sweetalert2";
import { db } from "../firebase";
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import { MdOutlineDateRange } from "react-icons/md";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { Modal, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router";

function MyDashboard() {
  const [leads, setLeads] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [coordinates, setCoordinates] = useState({}); // Store coordinates for each lead
  const [selectedState, setSelectedState] = useState("");
  const [selectedState2, setSelectedState2] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [locationInput, setLocationInput] = useState("");
  const [userId, setUserId] = useState("");

  const [showRefundModal, setShowRefundModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState("");
  const [refundReason, setRefundReason] = useState("");

  const stateAbbreviations = {
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    Washington: "WA",
    "West Virginia": "WV",
    Wisconsin: "WI",
    Wyoming: "WY",
  };
  const abbreviationsToState = Object.fromEntries(
    Object.entries(stateAbbreviations).map(([state, abbr]) => [abbr, state])
  );
  const fetchCoordinates = async (city, state) => {
    const stateName = abbreviationsToState[state] || "";
    const apiKey = process.env.REACT_APP_OPEN_CAGE_API_KEY;
    try {
      const response = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(`${city}, ${stateName}, USA`)}&key=${apiKey}&countrycode=us`
      );
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry;
        return {
          lat: parseFloat(lat),
          lon: parseFloat(lng),
        };
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
    return null;
  };
  
  const fetchCoordinates2 = async (location) => {
    const apiKey = process.env.REACT_APP_OPEN_CAGE_API_KEY;
    try {
      const response = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(location)}&key=${apiKey}&countrycode=us`
      );
  
      const data = await response.json();
  
      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry;
        const display_name = data.results[0].formatted;
  
        const addressParts = display_name.split(", ");
        const state = addressParts.find((part) =>
          part.match(
            /\b(Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming)\b/
          )
        );
  
        return { lat, lon: lng, state };
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
    return null;
  };
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchAllCoordinates = async () => {
      const coords = {};
      for (let i = 0; i < leads.length; i++) {
        const lead = leads[i];
        const coord = await fetchCoordinates(lead.city, lead.state);
        if (coord) {
          coords[i] = coord;
          setCoordinates((prev) => ({ ...prev, [i]: coord }));
  
          await sleep(1000);
        }
      }
    };
    fetchAllCoordinates();
  }, [leads]);
  

  const auth = getAuth();

  const apiKey = process.env.REACT_APP_API_KEY;

  const navigate = useNavigate();
  const [uid, setUid] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userId = user.uid;
        setUid(userId);

        // Fetch user data
        try {
          const userResponse = await fetch(
            `https://api.v1.spotyourleads.com/user/${userId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "x-api-key": apiKey,
              },
            }
          );

          if (!userResponse.ok) {
            throw new Error("Failed to fetch user data");
          }

          const userData = await userResponse.json();
          // console.log(userData);

          setUser(userData);
        } catch (error) {
          console.error("Error fetching user data:", error.message);
        }

        // Listen to Firestore snapshot and fetch leads
        const unsubscribeSnapshot = onSnapshot(
          collection(db, "leads"),
          async () => {
            try {
              const leadsResponse = await axios.get(
                `https://api.v1.spotyourleads.com/user/leads/${userId}`,
                {
                  headers: {
                    "x-api-key": apiKey,
                  },
                }
              );
              setLeads(leadsResponse.data || []);
            } catch (error) {
              console.error("Error fetching leads:", error);
            }
          },
          (error) => {
            console.error("Firestore onSnapshot error:", error);
          }
        );

        // Cleanup Firestore listener when user logs out
        return () => unsubscribeSnapshot();
      } else {
        setUid(null);
        setUser(null);
        navigate("/sign-in");
      }
    });

    return () => unsubscribeAuth();
  }, [auth, navigate]);

  const [selectedStatuses, setSelectedStatuses] = useState({});

  const statusOptions = {
    "Offer Sent": "Offer Sent",
    Declined: "Declined",
    "Under Contract": "Under Contract",
    "Closed Deal": "Closed Deal",
  };
  const showSuccess = (message) => {
    Swal.fire({
      icon: "success",
      title: "Success",
      text: message,
      timer: 2000,
      showConfirmButton: false,
    });
  };

  const showError = (message) => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
    });
  };
  const handleSelectChange = (leadId, newStatus) => {
    setSelectedStatuses((prev) => ({
      ...prev,
      [leadId]: newStatus,
    }));
  };
  const handleLocationInput = async (event) => {
    const location = event.target.value;
    if (!location || location.length < 0) {
      setSelectedState2("");
    }
    setLocationInput(location);

    if (location.length > 3) {
      const result = await fetchCoordinates2(location);
      if (result?.state) {
        setSelectedState2(result.state);
      }
    }
  };
  const handleStatusChange = async (leadId) => {
    const newStatus =
      selectedStatuses[leadId] || leads.find((l) => l.id === leadId)?.status;
    if (!newStatus || !statusOptions[newStatus])
      return showError("Please choose a valid status");

    const statusUrls = {
      "Offer Sent": `https://api.v1.spotyourleads.com/lead/offerSent?leadId=${leadId}&userId=${userId}`,
      Declined: `https://api.v1.spotyourleads.com/lead/declinedOffer?leadId=${leadId}&userId=${userId}`,
      "Under Contract": `https://api.v1.spotyourleads.com/lead/underContract?leadId=${leadId}&userId=${userId}`,
      "Closed Deal": `https://api.v1.spotyourleads.com/lead/closedDeal?leadId=${leadId}&userId=${userId}`,
    };

    try {
      const response = await fetch(statusUrls[newStatus], {
        method: "POST",
        headers: { "x-api-key": apiKey },
      });

      if (!response.ok) throw new Error("Failed to update status");

      showSuccess(`Lead status updated to ${newStatus}`);

      setLeads((prevLeads) =>
        prevLeads?.map((lead) =>
          lead.id === leadId ? { ...lead, status: newStatus } : lead
        )
      );

      setSelectedStatuses((prev) => ({
        ...prev,
        [leadId]: newStatus,
      }));
    } catch (error) {
      showError("Error updating lead status");
      console.error("API Error:", error);
    }
  };
  const filteredLeads = Array.isArray(leads)
    ? leads.filter(
        (lead) =>
          (!selectedState || lead.state === selectedState) &&
          (!selectedState2 || lead.state === selectedState2) &&
          (!statusFilter || lead.dashboardStatus === statusFilter) &&
          (!selectedPropertyType || lead.propertyType === selectedPropertyType)
      )
    : [];
  const exportLeadsToCSV = () => {
    const dataToExport = filteredLeads.length > 0 ? filteredLeads : leads;
    if (!dataToExport || dataToExport.length === 0) {
      return Swal.fire("No data", "There are no leads to export", "info");
    }

    // grab all keys from the first lead
    const headers = Object.keys(dataToExport[0]);
    const csvRows = [
      headers.join(","), // header row
      ...dataToExport.map((item) =>
        headers
          .map((field) => {
            let val = item[field];
            if (Array.isArray(val)) return `"${val.join(",")}"`;
            if (typeof val === "string") return `"${val.replace(/"/g, '""')}"`;
            return val ?? "";
          })
          .join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "leads.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const toggleDetails = (index) => {
    if (expandedIndex === index) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };
  const openRefundModal = (leadId) => {
    setSelectedLeadId(leadId);
    setShowRefundModal(true);
  };

  const closeRefundModal = () => {
    setShowRefundModal(false);
    setRefundReason("");
  };
  const handleRefundRequest = async () => {
    if (!refundReason) {
      showError("Please enter a refund reason");
      return;
    }

    try {
      const response = await fetch(
        "https://api.v1.spotyourleads.com/lead/requestRefund",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
          body: JSON.stringify({
            userId: userId,
            leadId: selectedLeadId,
            refundReason: refundReason,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit refund request");
      }

      const data = await response.json();
      showSuccess("Refund request submitted successfully");
      closeRefundModal();
    } catch (error) {
      console.error("Error submitting refund request:", error);
      showError("Error submitting refund request");
    }
  };
  const sendLeadsToWebhook = async () => {
    if (!uid) return;
  
    try {
      const response = await axios.post(
        "https://api.v1.spotyourleads.com/user/send-leads",
        new URLSearchParams({ userId: uid }).toString(),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "x-api-key": apiKey,
          },
        }
      );
  
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Leads sent successfully to webhook!',
      });
    } catch (error) {
      console.error("Error sending leads:", error);
  
      const backendError =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An error occurred while sending leads.";
  
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: backendError,
      });
    }
  };
  
  return (
    <>
      <Helmet>
        <title>Spot Your Leads | Manage Your Leads & Account Easily</title>
      </Helmet>
      <section className="leadsShop">
        <Container>
          <div className="pricing-title">
            <h2>All Leads</h2>
            {leads?.length > 0 ? (
              <button
              style={{ backgroundColor:"#6ABC45" ,color:"#fff"}}
                className="btn  mb-3 mx-5"
                onClick={exportLeadsToCSV}
              >
                Export to CSV
              </button>
            ) : null}

            {leads?.length > 0 && user?.webhookUrl ? (
              <button
              style={{ backgroundColor:"#6ABC45" ,color:"#fff"}}

                className="btn  mb-3 mx-5"
                onClick={sendLeadsToWebhook}
              >
                Send Leads to Webhook
              </button>
            ) : null}
          </div>
          <div>
            <div className="inquiry">
              <Container>
                <Row>
                  <Col lg={12} md={12} sm={12}>
                    <div className="formDiv">
                      <form
                      // onSubmit={handlePasswordChange}
                      >
                        <div className="row justify-content-between mt-1">
                          <div className="col-md-6">
                            <input
                              className="form-control"
                              name="location"
                              type="text"
                              placeholder="Enter Location"
                              value={locationInput}
                              onChange={handleLocationInput}
                            />
                          </div>
                          <div className="col-md-2">
                            <select
                              className="form-control"
                              value={selectedState}
                              onChange={(e) => setSelectedState(e.target.value)}
                            >
                              <option value="">Select State</option>
                              {Object.entries(stateAbbreviations).map(
                                ([fullName, abbreviation]) => (
                                  <option key={abbreviation} value={fullName}>
                                    {abbreviation}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <div className="col-md-2">
                            <select
                              className="form-control"
                              name="propertyType"
                              value={selectedPropertyType}
                              onChange={(e) =>
                                setSelectedPropertyType(e.target.value)
                              }
                            >
                              <option value="">Property Type</option>
                              <option value="Single family">
                                Single family
                              </option>
                              <option value="Ranch">Ranch</option>
                              <option value="2-story">2-story</option>
                              <option value="Mobile home owned land">
                                Mobile home owned land
                              </option>
                              <option value="Mobile home rented land">
                                Mobile home rented land
                              </option>
                              <option value="Multifamily">Multifamily</option>
                              <option value="Bungalow">Bungalow</option>
                              <option value="Cottage">Cottage</option>
                              <option value="Townhouse">Townhouse</option>
                              <option value="Condominium">Condominium</option>
                              <option value="Duplex">Duplex</option>
                              <option value="Farmhouse">Farmhouse</option>
                              <option value="Split-level home">
                                Split-level home
                              </option>
                              <option value="Land">Land</option>
                              <option value="Commercial Property">
                                Commercial Property
                              </option>
                            </select>
                          </div>
                          <div className="col-md-2">
                            <select
                              className="form-control"
                              name="Status"
                              value={statusFilter}
                              onChange={(e) => setStatusFilter(e.target.value)}
                            >
                              <option value="">Status</option>
                              <option value="Offer Sent">Offer Sent</option>
                              <option value="Under Contract">
                                Under Contract
                              </option>
                              <option value="Declined"> Declined</option>
                              <option value="Closed Deal">Closed Deal</option>
                            </select>
                          </div>
                        </div>
                        {leads == 0 ? (
                          <div className="orders">
                            <p>No Orders</p>
                          </div>
                        ) : null}
                      </form>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <Container>
              <Row>
                {filteredLeads?.map((lead, index) => (
                  <Col key={index} lg={12} md={12} sm={12}>
                    <div
                      className="leads-items row"
                      style={{
                        height:
                          expandedIndex === index
                            ? "auto"
                            : window.innerWidth >= 768
                            ? "100px"
                            : "350px",

                        overflow: "hidden",
                        transition: "height 0.3s ease",
                        border: "1px solid #ddd",
                        margin: "15px 0",
                        padding: "15px",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          textAlign: "center",
                        }}
                      >
                        <button
                          onClick={() => toggleDetails(index)}
                          style={{
                            padding: "5px",
                            cursor: "pointer",
                            width: "100px",
                            borderRadius: "4px",
                            border: "none",
                            backgroundColor: "#007bff",
                            color: "#fff",
                            position: "absolute",
                            bottom: "1px",
                            right: "1px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            justifyContent: "center",
                            fontSize: "10px",
                          }}
                        >
                          {expandedIndex === index ? (
                            <>
                              Load Less{" "}
                              <FaAngleUp style={{ fontSize: "12px" }} />
                            </>
                          ) : (
                            <>
                              Load More{" "}
                              <FaAngleDown style={{ fontSize: "12px" }} />
                            </>
                          )}
                        </button>
                      </div>
                      <div className="col-md-4">
                        {coordinates[index] && (
                          <iframe
                            src={`https://maps.google.com/maps?q=${coordinates[index].lat},${coordinates[index].lon}&z=10&output=embed`}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            style={{ width: "100%", height: "300px" }}
                          ></iframe>
                        )}
                      </div>
                      <div className="col-md-4">
                        <p className="date-lead">
                          <MdOutlineDateRange />
                          {new Date(lead.acceptedAt * 1000).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            }
                          )}{" "}
                          {new Date(lead.acceptedAt * 1000)
                            .toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .toLowerCase()}
                        </p>
                        {/* <p>
                                                                                             <strong>Price:</strong> ${lead.price}  {lead.status == "discounted" || lead.status == "free" ? <span className={lead.status}>{lead.status == "discounted" ? "50% off" : lead.status}</span> : null} <br />
                                                                                         </p> */}
                        <p>
                          <strong>Address:</strong> {lead.propertyAddress}{" "}
                          <br />
                        </p>

                        <p>
                          <strong>Property Type:</strong> {lead.propertyType}{" "}
                          <br />
                        </p>
                        <p>
                          <strong>Owner:</strong> {lead.propertyOwner} <br />
                        </p>
                        <p>
                          <strong>Lead Notes:</strong>

                          <div
                            dangerouslySetInnerHTML={{
                              __html: lead.leadTemplate,
                            }}
                          />
                        </p>
                        <p>
                          <strong>Reason for Selling:</strong>{" "}
                          {lead.sellingReason} <br />
                        </p>
                        <p>
                          <strong>Mortgage:</strong> {lead.hasMortgage} <br />
                        </p>
                        <select
                          value={
                            selectedStatuses[lead.id] || lead.dashboardStatus
                          } // Ensure dashboardStatus is reflected
                          onChange={(e) =>
                            handleSelectChange(lead.id, e.target.value)
                          }
                          className="select-status "
                        >
                          <option value="">Select Status</option>
                          {Object.keys(statusOptions).map((status) => (
                            <option key={status} value={status}>
                              {status}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={() => handleStatusChange(lead.id)}
                          className="update status-change"
                        >
                          Change Status
                        </button>
                      </div>
                      <div className="col-md-4">
                        <div>
                          <p>
                            <strong>Owned Years:</strong> {lead.ownedYears}{" "}
                            <br />
                          </p>
                          <p>
                            <strong>Occupancy :</strong> {lead.livingStatus}{" "}
                            <br />
                          </p>
                          <p>
                            <strong>Property Listed:</strong>{" "}
                            {lead.propertyListed} <br />
                          </p>
                          <p>
                            <strong>Phone Number:</strong> {lead.phoneNumber}{" "}
                            <br />
                          </p>
                          <p>
                            <strong>Repairs Needed:</strong>{" "}
                            <span
                              style={{ fontSize: "14px", color: "#1f1f1f" }}
                            >
                              {" "}
                              {lead?.repairsNeeded
                                ?.filter((item) =>
                                  lead?.repairsNeeded.includes(item)
                                )
                                .join(", ") + "."}
                            </span>
                            <br />
                          </p>
                          <p>
                            <strong>State:</strong> {lead.state} <br />
                          </p>
                          <p>
                            <strong>City:</strong> {lead.city} <br />
                          </p>

                          <p>
                            <strong>Closing Time:</strong> {lead.closingTime}{" "}
                            <br />
                          </p>

                          <button
                            onClick={() => openRefundModal(lead.id)}
                            className="update status-change"
                          >
                            Request Refund
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </div>
          {showRefundModal && (
            <Modal show={showRefundModal} onHide={closeRefundModal} centered>
              <Modal.Header closeButton>
                <Modal.Title>Request Refund</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group controlId="refundReason">
                  <Form.Label>Reason for Refund:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={refundReason}
                    onChange={(e) => setRefundReason(e.target.value)}
                    placeholder="Enter your refund reason..."
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  style={{
                    backgroundColor: "white",
                    color: "#6ABC45",
                    border: "1px solid #6ABC45",
                  }}
                  onClick={closeRefundModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  style={{
                    backgroundColor: "#6ABC45",
                    color: "#fff",
                    border: "none",
                  }}
                  onClick={handleRefundRequest}
                >
                  Submit Request
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
      </section>
      <Footer />
    </>
  );
}

export default MyDashboard;
